/**
 * Makes elements the same height
 */
(function($) {
    $.fn.c24EqualHeights = function() {
        let height = 0;
        $(this).each(function() {
            if ($(this).height() > height) {
                height = $(this).height();
            }
        });
        $(this).css('min-height', (height + 2) + 'px');
    };

    /**
     * Fixed Column Heights
     */
    window.c24EqualColumns = function() {
        $('.div24Row > .mod24Box:not(.noequalheights)').each(function() {
            if ($(this).closest('.div24Col').length) {
                $(this).c24EqualHeights();
            }
        });
    };

})(jQuery);
